





























































































import Vue, { PropType } from "vue"
import PTopBoard from "./items/PTopBoard.vue"
import PBaseInfo from "./items/PBaseInfo.vue"
import PSkillTag from "./items/PSkillTag.vue"
import PSocialLinks from "./items/PSocialLinks.vue"
import PCareers from "./items/PCareers.vue"
import PCapabilities from "./items/PCapabilities.vue"
import PPortfolio from "./items/PPortfolio.vue"
import PSupplementaryExplanation from "./items/PSupplementaryExplanation.vue"
import PSelfIntroduction from "./items/PSelfIntroduction.vue"
import PPhilosophy from "./items/PPhilosophy.vue"
import PBoundaryLine from "./items/PBoundaryLine.vue"
import { OutputOGP } from "~/backendApis/viewModel/common"
import {
  UserProfileSearchResultView,
  decorateUserProfileSearchResultView,
} from "~/backendApis/viewModel/userProfileSearch"

export default Vue.extend({
  components: {
    PTopBoard,
    PBaseInfo,
    PSkillTag,
    PSocialLinks,
    PCareers,
    PCapabilities,
    PPortfolio,
    PSupplementaryExplanation,
    PSelfIntroduction,
    PPhilosophy,
    PBoundaryLine,
  },
  props: {
    userProfile: {
      type: Object as PropType<UserProfileSearchResultView>,
      required: true,
    },
  },
  computed: {
    userProfileDecorator(): ReturnType<
      typeof decorateUserProfileSearchResultView
    > {
      return decorateUserProfileSearchResultView(this.userProfile)
    },
    mainCorporationName(): string | undefined {
      return this.userProfileDecorator.getMainExperienceCorporation()
        ?.corporationName
    },
    mainCorporationEnrolledStatus(): boolean | undefined {
      return this.userProfileDecorator.getMainExperienceCorporation()
        ?.isCurrentCorporation
    },
    outputOGPs(): OutputOGP[] {
      return this.userProfileDecorator.getOutputOGPs()
    },
  },
  mounted(): void {
    this.userProfileDecorator.loadOutputOGPs()
  },
})
